import "./App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { useVisitCounter, usePageViewTracker } from "./hooks/useVisitCounter";

const Home = lazy(() => import("./pages/Home").then(m => ({ default: m.Home })));
const About = lazy(() => import("./pages/About").then(m => ({ default: m.About })));
const Services = lazy(() => import("./pages/Services").then(m => ({ default: m.Services })));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail").then(m => ({ default: m.ServiceDetail })));
const Contact = lazy(() => import("./pages/Contact").then(m => ({ default: m.Contact })));
const PillarPage = lazy(() => import("./pages/PillarPage").then(m => ({ default: m.PillarPage })));
const Visitors = lazy(() => import("./pages/Visitors").then(m => ({ default: m.Visitors })));
const NotFound = lazy(() => import("./pages/NotFound").then(m => ({ default: m.NotFound })));

function VisitTracker() {
  useVisitCounter();
  usePageViewTracker();
  return null;
}

// Remonte en haut à chaque changement de page ; si l'URL porte une ancre
// (/#realisations, #exemples), défile jusqu'à elle une fois la page (lazy) rendue.
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    let tries = 0;
    const timer = setInterval(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target || ++tries > 20) {
        clearInterval(timer);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 50);
    return () => clearInterval(timer);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VisitTracker />
        <ScrollManager />
        <Header />
        <main className="main-content">
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/creation-web" element={<PillarPage slug="creation-web" />} />
              <Route path="/intelligence-artificielle" element={<PillarPage slug="intelligence-artificielle" />} />
              <Route path="/cloud-devops" element={<PillarPage slug="cloud-devops" />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/visitors" element={<Visitors />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
